import type { TFunction } from 'i18next';
import type { IBlackboardEntry, ISchedulerTask, ISiteFloor } from '@interfaces/IScheduler';
import { areaFloorNames } from '@d-orca/shared/client/activities';
import { professionLabel } from '@components/ui/ProfessionPill/professionLabel';

/**
 * A 黒板 filled in from what the task already knows (task-checklist design,
 * decision 9): the work type is its profession, the location its floors, the
 * date today on site — all editable before the tick is saved. `today` is ''
 * while the site's zone is unresolved: an empty date is honest, a guessed one
 * is not.
 */
export function blackboardDefaults(
  t: TFunction,
  task: Pick<ISchedulerTask, 'profession' | 'locations'>,
  floors: readonly ISiteFloor[],
  today: string,
): Required<IBlackboardEntry> {
  return {
    workType: task.profession ? professionLabel(t, task.profession) : '',
    location: areaFloorNames((task.locations ?? []).map((l) => l.locationId), floors).join(' · '),
    date: today,
  };
}
